module.exports = __webpack_public_path__ + "img/33.7050cc3c.jpg";